import ElRow from './Row.js'

/* istanbul ignore next */
ElRow.install = function (app) {
  app.component(ElRow.name, ElRow)
}

export default ElRow
